import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient"; // centralized axios instance

const API_URL = "/empData/";

// Fetch Employees
export const fetchEmployees = createAsyncThunk("empData/fetchEmployees", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API_URL);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Insert Employee
export const insertEmployee = createAsyncThunk("empData/insertEmployee", async (employee, { rejectWithValue }) => {
  try {
    const response = await apiClient.post(API_URL, employee);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Update Employee
export const updateEmployee = createAsyncThunk("empData/updateEmployee", async (employee, { rejectWithValue }) => {
  try {
    const response = await apiClient.put(`${API_URL}${employee.id}/`, employee);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Delete Employee
export const deleteEmployee = createAsyncThunk("empData/deleteEmployee", async (id, { rejectWithValue }) => {
  try {
    await apiClient.delete(`${API_URL}${id}/`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

const empDataSlice = createSlice({
  name: "empData",
  initialState: {
    employees: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.employees = action.payload;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(insertEmployee.fulfilled, (state, action) => {
        state.employees.push(action.payload);
      })
      .addCase(insertEmployee.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateEmployee.fulfilled, (state, action) => {
        const index = state.employees.findIndex((e) => e.id === action.payload.id);
        if (index !== -1) {
          state.employees[index] = action.payload;
        }
      })
      .addCase(updateEmployee.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteEmployee.fulfilled, (state, action) => {
        state.employees = state.employees.filter((employee) => employee.id !== action.payload);
      })
      .addCase(deleteEmployee.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default empDataSlice.reducer;
